var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#434247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 2.25C7.22298 2.25 5.51876 2.95591 4.26222 4.21245C3.00569 5.46898 2.29977 7.17321 2.29977 8.95022C2.29977 10.7272 3.00569 12.4315 4.26222 13.688C5.51876 14.9445 7.22298 15.6504 8.99999 15.6504C12.7007 15.6504 15.6999 12.6506 15.6999 8.94994C15.6999 5.24981 12.7012 2.25 8.99999 2.25ZM8.99999 15.3793C5.44612 15.3793 2.56499 12.4982 2.56499 8.94431C2.56499 5.39156 5.44668 2.51044 8.99999 2.51044C12.5533 2.51044 15.435 5.39156 15.435 8.94544C15.435 12.4987 12.5539 15.3793 8.99999 15.3793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73574 9.6086H11.4345V12.1151C11.4345 12.3637 11.1797 12.4965 10.9367 12.6242C10.6987 12.7513 10.3112 12.7237 9.65811 12.7237H8.86161C7.63874 12.7513 7.29562 12.6574 7.00255 12.5297C6.70949 12.3969 6.55986 12.209 6.55986 11.9655V9.6086H5.68011V12.2642C5.68011 12.4082 5.75212 12.5741 5.86293 12.7237C5.99005 12.8953 5.97374 12.9448 6.24993 13.0832C6.49911 13.2103 6.7483 13.3099 7.19605 13.3655C7.5448 13.4094 7.48405 13.3987 8.10393 13.4094H9.57543C10.6819 13.3875 10.9086 13.4651 11.5667 13.1332C12.1039 12.8672 12.2867 12.5578 12.3249 12.3581V8.74573H9.74137V9.6086M7.44524 4.49604C6.99693 4.52416 6.62624 4.66254 6.3388 4.77279C6.04574 4.8836 5.98443 5.01635 5.86293 5.16035C5.75043 5.29085 5.68743 5.45791 5.68574 5.6306V8.57416H6.57112V5.91185C6.57112 5.68516 6.70949 5.50291 6.98061 5.37016C7.25736 5.23179 7.66124 5.16541 8.03755 5.16541H9.7633C10.4214 5.16541 10.7758 5.15416 10.9806 5.27566C11.1909 5.40841 11.4401 5.52485 11.4401 5.77404V6.4766H12.3249V5.53104C12.3086 5.40898 12.1759 5.06079 11.5504 4.76716C10.9862 4.50166 10.8039 4.48535 9.91855 4.48535",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgch);
export default __webpack_public_path__ + "static/media/tgch.49588730687d8ea26a8bcb150f9166e6.svg";
export { ForwardRef as ReactComponent };